<p-button
  [label]="loading ? '' : label"
  [disabled]="isDisabled"
  [ngClass]="getButtonClasses()"
  [type]="type"
  [routerLink]="routerLink"
  [style.--button-custom-color]="color"
  class="custom-button"
  (click)="handleClick($event)">
  @if (loading) {
    <span class="custom-spinner" aria-hidden="true"></span>
  } @else if (icon) {
    <lucide-icon [name]="icon" class="custom-icon"></lucide-icon>
  }
</p-button>